// Application constants and externalized strings

export const STRINGS = {
  LOGIN: {
    TITLE: 'Đăng Nhập',
    SUBTITLE: 'Vui lòng nhập thông tin đăng nhập của bạn',
    USERNAME_LABEL: 'Tên đăng nhập',
    PASSWORD_LABEL: 'Mật khẩu',
    SUBMIT_BUTTON: 'Đăng Nhập',
    LOADING: 'Đang đăng nhập...',
    ERRORS: {
      USERNAME_REQUIRED: 'Tên đăng nhập không được để trống',
      PASSWORD_REQUIRED: 'Mật khẩu không được để trống',
      INVALID_CREDENTIALS: 'Tên đăng nhập hoặc mật khẩu không đúng',
      SYSTEM_ERROR: 'Lỗi hệ thống. Vui lòng thử lại sau',
      NETWORK_ERROR: 'Đăng nhập thất bại. Vui lòng kiểm tra kết nối mạng',
      RATE_LIMITED: 'Quá nhiều lần thử đăng nhập. Vui lòng thử lại sau 15 phút',
      USERNAME_TOO_SHORT: 'Tên đăng nhập phải có ít nhất 3 ký tự',
      USERNAME_TOO_LONG: 'Tên đăng nhập không được vượt quá 50 ký tự',
      USERNAME_INVALID_CHARS: 'Tên đăng nhập chỉ được chứa chữ cái, số, gạch dưới và gạch ngang',
      PASSWORD_TOO_SHORT: 'Mật khẩu phải có ít nhất 6 ký tự',
      PASSWORD_TOO_LONG: 'Mật khẩu không được vượt quá 128 ký tự',
    },
  },
} as const;

export const SECURITY = {
  MAX_USERNAME_LENGTH: 50,
  MIN_USERNAME_LENGTH: 3,
  MAX_PASSWORD_LENGTH: 128,
  MIN_PASSWORD_LENGTH: 6,
  RATE_LIMIT_ATTEMPTS: 5,
  RATE_LIMIT_WINDOW_MS: 15 * 60 * 1000, // 15 minutes
} as const;
